/* ===========================================================================
   BioKingLabs — Turkesterone theme behavior
   Vanilla JS over Shopify's native AJAX Cart API. No framework.
   Handles: offer selection, subscribe & save, add-to-cart, slide-in cart
   drawer (rendered from /cart.js), qty steppers, sticky buy bar, mobile menu,
   FAQ accordion, reviews filter, gallery thumbnails, and scroll reveal.
   Checkout is Shopify's hosted, PCI-compliant flow — we hand off at /checkout.
   =========================================================================== */
(function () {
  "use strict";

  var CFG = window.BKL || {};
  var FREE_SHIP = (CFG.freeShipThreshold != null ? CFG.freeShipThreshold : 5000); // cents
  var routes = CFG.routes || {};
  var cartAdd = routes.cart_add_url || "/cart/add";
  var cartUrl = routes.cart_url || "/cart";
  var cartChange = routes.cart_change_url || "/cart/change";

  var moneyFmt;
  try {
    moneyFmt = new Intl.NumberFormat(CFG.locale || "en-US", {
      style: "currency",
      currency: CFG.currency || "USD",
    });
  } catch (e) {
    moneyFmt = { format: function (n) { return "$" + n.toFixed(2); } };
  }
  function money(cents) { return moneyFmt.format((cents || 0) / 100); }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- toast ---------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.innerHTML = '<span class="ic"><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></span><span class="toast-msg"></span>';
      document.body.appendChild(toastEl);
    }
    $(".toast-msg", toastEl).textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add("show"); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }

  /* ---------------- cart drawer ---------------- */
  var drawer, scrim, lastFocus;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("show");
    scrim.classList.add("show");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("bkl-lock");
    var close = drawer.querySelector("[data-cart-close]");
    if (close) close.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("show");
    scrim.classList.remove("show");
    drawer.setAttribute("aria-hidden", "true");
    if (!document.querySelector("[data-mobile-menu].show")) document.documentElement.classList.remove("bkl-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function cartIsOpen() { return drawer && drawer.classList.contains("show"); }

  // Serialize cart writes so rapid +/- clicks don't desync the quantity.
  var cartChain = Promise.resolve();
  function queueCart(fn) {
    cartChain = cartChain.then(fn, fn);
    return cartChain;
  }

  function updateCartCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  function renderCart(cart) {
    if (!drawer) return;
    updateCartCount(cart.item_count);

    var itemsEl = $(".cart-items", drawer);
    var footEl = $(".drawer-foot", drawer);
    var shipEl = $(".ship-bar", drawer);

    if (!cart.items.length) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 3H2"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>' +
        "<p>Your cart is empty.</p>" +
        '<button class="btn btn-glass" data-cart-close style="margin-top:18px">Continue shopping</button>' +
        "</div>";
      if (footEl) footEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      return;
    }
    if (footEl) footEl.hidden = false;
    if (shipEl) shipEl.hidden = false;

    /* free-shipping progress */
    var toFree = Math.max(0, FREE_SHIP - cart.total_price);
    var pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
    shipEl.innerHTML =
      '<div class="lbl">' +
      (toFree > 0 ? "Add <b>" + money(toFree) + "</b> for free shipping" : "<b>Free shipping included on your order</b>") +
      "</div>" +
      '<div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div>';

    /* line items */
    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, "_120x$1$2")
        : "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      var sub = item.selling_plan_allocation ? "Subscribe & save" : "";
      var sublabel = [variant, sub].filter(Boolean).join(" · ");
      var bundle = propValue(item, "Bundle");
      var line2 = bundle || sublabel || item.product_type || "";
      return (
        '<div class="ci" data-line-key="' + item.key + '">' +
        (img ? '<img class="ci-img" src="' + img + '" alt="">' : '<div class="ci-img"></div>') +
        '<div class="ci-mid">' +
        '<div class="t">' + escapeHtml(item.product_title) + "</div>" +
        (line2 ? '<div class="v">' + escapeHtml(line2) + (sub && !bundle ? "" : (sub && bundle ? " · " + sub : "")) + "</div>" : "") +
        '<div class="ci-step">' +
        '<button data-qty-down aria-label="Decrease">−</button>' +
        '<span class="n">' + item.quantity + "</span>" +
        '<button data-qty-up aria-label="Increase">+</button>' +
        "</div>" +
        "</div>" +
        '<div class="ci-right">' +
        '<div class="p">' + money(item.final_line_price) + "</div>" +
        '<button class="rm" data-qty-remove>Remove</button>' +
        "</div>" +
        "</div>"
      );
    }).join("");

    /* gifts (from line-item "Free gifts" properties) */
    var gifts = collectGifts(cart);
    var giftsHtml = gifts.length
      ? '<div class="co-gifts"><div class="gh">Included free</div><ul>' +
        gifts.map(function (g) {
          return '<li><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>' + escapeHtml(g) + "</li>";
        }).join("") +
        "</ul></div>"
      : "";

    var saved = (cart.original_total_price || 0) - cart.total_price;
    footEl.innerHTML =
      giftsHtml +
      (saved > 0 ? '<div class="sub-row"><span class="sl">You save</span><span class="amt sv-amt">−' + money(saved) + "</span></div>" : "") +
      '<div class="sub-row tot"><span class="sl">Subtotal</span><span class="amt">' + money(cart.total_price) + "</span></div>" +
      '<button class="btn btn-primary btn-block" data-checkout>Checkout · ' + money(cart.total_price) + "</button>" +
      '<div class="fine">Taxes &amp; shipping calculated at checkout · 256-bit secure</div>';
  }

  function propValue(item, key) {
    if (!item.properties) return "";
    return item.properties[key] || "";
  }
  function collectGifts(cart) {
    var set = [];
    cart.items.forEach(function (item) {
      var g = propValue(item, "Free gifts");
      if (g) {
        g.split("|").forEach(function (p) {
          p = p.trim();
          if (p && set.indexOf(p) === -1) set.push(p);
        });
      }
    });
    return set;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fetchCart() {
    return fetch(cartUrl + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(payload, opts) {
    opts = opts || {};
    return queueCart(function () {
      return fetch(cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.data && res.data.description ? res.data.description : "Couldn't add to cart");
            return;
          }
          return fetchCart().then(function () {
            if (opts.open !== false) openCart();
            toast(opts.message || "Added to your cart");
          });
        })
        .catch(function () { toast("Network error - please try again"); });
    });
  }

  function changeLine(key, qty) {
    return queueCart(function () {
      return fetch(cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (r) {
          // On a 422 (e.g. stock limit) Shopify returns an error object, not a cart.
          if (!r.ok) return fetchCart();
          return r.json().then(function (cart) { renderCart(cart); return cart; });
        })
        .catch(function () { return fetchCart(); });
    });
  }

  /* ---------------- product (hero-pdp) wiring ---------------- */
  function initProduct() {
    var form = $("[data-pdp]");
    if (!form) return;

    var offers = $all("[data-offer]", form);
    var subToggle = $("[data-sub-toggle]", form);
    var atc = $("[data-atc]", form);
    var atcNow = $("[data-atc-now]", form);
    var atcWas = $("[data-atc-was]", form);

    var state = { offerEl: null, subscribe: false };

    function perFor(el, sub) {
      return sub ? el.getAttribute("data-per-sub") : el.getAttribute("data-per");
    }

    function refresh() {
      var el = state.offerEl;
      if (!el) return;
      offers.forEach(function (o) { o.classList.toggle("sel", o === el); });
      offers.forEach(function (o) {
        var perEl = $("[data-offer-per]", o);
        if (perEl) perEl.textContent = perFor(o, state.subscribe);
        var totEl = $("[data-offer-total]", o);
        if (totEl) totEl.textContent = (o.getAttribute(state.subscribe ? "data-total-sub-display" : "data-total-display") || totEl.textContent);
      });
      var nowTxt = el.getAttribute(state.subscribe ? "data-total-sub-display" : "data-total-display");
      if (atcNow && nowTxt) atcNow.textContent = nowTxt;
      if (atcWas) atcWas.textContent = el.getAttribute("data-compare-display") || "";
      if (subToggle) subToggle.classList.toggle("on", state.subscribe);
      syncFormFields(el);
      updateStickyBar(el);
    }

    // Keep the product form's hidden fields in sync so Shopify's dynamic
    // checkout buttons (Shop Pay / Apple Pay / PayPal) use the selected offer.
    function syncFormFields(el) {
      var idField = $("[data-form-id]", form);
      var qtyField = $("[data-form-qty]", form);
      var extra = $("[data-form-extra]", form);
      if (idField) idField.value = el.getAttribute("data-variant-id") || form.getAttribute("data-default-variant") || "";
      if (qtyField) qtyField.value = el.getAttribute("data-quantity") || "1";
      if (!extra) return;
      extra.innerHTML = "";
      var label = el.getAttribute("data-label");
      var gifts = el.getAttribute("data-gifts");
      if (label) extra.appendChild(hidden("properties[Bundle]", label));
      if (gifts) extra.appendChild(hidden("properties[Free gifts]", gifts));
      if (state.subscribe) {
        var sp = el.getAttribute("data-selling-plan") || form.getAttribute("data-default-selling-plan");
        if (sp) extra.appendChild(hidden("selling_plan", sp));
      }
    }
    function hidden(name, value) {
      var i = document.createElement("input");
      i.type = "hidden"; i.name = name; i.value = value;
      return i;
    }

    function updateStickyBar(el) {
      var bar = $("[data-buybar]");
      if (!bar || !el) return;
      var t = $("[data-buybar-title]", bar);
      var s = $("[data-buybar-sub]", bar);
      var price = $("[data-buybar-price]", bar);
      var was = $("[data-buybar-was]", bar);
      if (t) t.textContent = "Turkesterone · " + (el.getAttribute("data-label") || "");
      if (s) s.textContent = (el.getAttribute("data-deal") || "") + (state.subscribe ? " · Subscribe & save" : "");
      if (price) price.textContent = el.getAttribute(state.subscribe ? "data-total-sub-display" : "data-total-display") || "";
      if (was) was.textContent = el.getAttribute("data-compare-display") || "";
    }

    offers.forEach(function (o) {
      o.addEventListener("click", function () { state.offerEl = o; refresh(); });
    });
    if (subToggle) {
      subToggle.addEventListener("click", function () { state.subscribe = !state.subscribe; refresh(); });
    }

    // default selection: the offer flagged data-default, else first
    state.offerEl = form.querySelector("[data-offer][data-default]") || offers[0] || null;
    refresh();

    function buildPayload(el) {
      var variantId = el.getAttribute("data-variant-id") || form.getAttribute("data-default-variant");
      var qty = parseInt(el.getAttribute("data-quantity") || "1", 10);
      var payload = { id: Number(variantId), quantity: qty };
      var props = {};
      var label = el.getAttribute("data-label");
      if (label) props["Bundle"] = label;
      var gifts = el.getAttribute("data-gifts");
      if (gifts) props["Free gifts"] = gifts;
      if (Object.keys(props).length) payload.properties = props;
      if (state.subscribe) {
        var sp = el.getAttribute("data-selling-plan") || form.getAttribute("data-default-selling-plan");
        if (sp) payload.selling_plan = Number(sp);
      }
      return payload;
    }

    if (atc) {
      atc.addEventListener("click", function (e) {
        e.preventDefault();
        if (!state.offerEl) return;
        var payload = buildPayload(state.offerEl);
        if (!payload.id) { toast("Select an option"); return; }
        addToCart(payload);
      });
    }

    // sticky buy bar add
    var barAdd = $("[data-buybar-add]");
    if (barAdd) barAdd.addEventListener("click", function () { if (state.offerEl) addToCart(buildPayload(state.offerEl)); });

    // sticky bar reveal on hero scroll-out
    var hero = $("[data-hero]");
    var bar = $("[data-buybar]");
    if (hero && bar) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var out = hero.getBoundingClientRect().bottom < 0;
          bar.classList.toggle("show", out && !cartIsOpen());
          ticking = false;
        });
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    // gallery carousel (swipe on mobile, thumbnails on desktop)
    var stage = $("[data-gallery-stage]");
    var slides = $all("[data-slide]", stage);
    var thumbs = $all("[data-thumb]");
    var dots = $all("[data-dot]");

    function setActive(i) {
      slides.forEach(function (s, idx) { s.classList.toggle("active", idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle("active", idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle("active", idx === i); });
    }
    // desktop thumbnails switch the shown slide
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { setActive(parseInt(t.getAttribute("data-index"), 10)); });
    });
    // mobile dots scroll the swipe carousel
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        var i = parseInt(d.getAttribute("data-index"), 10);
        if (stage) stage.scrollTo({ left: i * stage.clientWidth, behavior: "smooth" });
        setActive(i);
      });
    });
    // sync active state as the user swipes
    if (stage) {
      var gtick = false;
      stage.addEventListener("scroll", function () {
        if (gtick) return; gtick = true;
        requestAnimationFrame(function () {
          if (stage.clientWidth) setActive(Math.round(stage.scrollLeft / stage.clientWidth));
          gtick = false;
        });
      }, { passive: true });
    }
  }

  /* ---------------- stack & save add buttons (self-contained) ---------------- */
  function initStack() {
    $all("[data-stack-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = Number(btn.getAttribute("data-variant-id"));
        if (!id) { toast("Select an option"); return; }
        var payload = { id: id, quantity: parseInt(btn.getAttribute("data-quantity") || "1", 10) };
        var props = {};
        if (btn.getAttribute("data-label")) props["Bundle"] = btn.getAttribute("data-label");
        if (btn.getAttribute("data-gifts")) props["Free gifts"] = btn.getAttribute("data-gifts");
        if (Object.keys(props).length) payload.properties = props;
        addToCart(payload);
      });
    });
  }

  /* ---------------- reviews filter ---------------- */
  function initReviews() {
    var section = $("[data-reviews]");
    if (!section) return;
    var chips = $all("[data-filter]", section);
    var cards = $all("[data-review]", section);
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("active"); });
        chip.classList.add("active");
        var f = chip.getAttribute("data-filter");
        cards.forEach(function (card) {
          var stars = parseInt(card.getAttribute("data-stars") || "0", 10);
          var hasPhoto = card.getAttribute("data-photo") === "true";
          var show = f === "all" || (f === "5" && stars === 5) || (f === "photo" && hasPhoto);
          card.hidden = !show;
        });
      });
    });
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq() {
    $all("[data-faq]").forEach(function (faq) {
      var items = $all(".faq-item", faq);
      items.forEach(function (item) {
        var btn = $(".faq-q", item);
        var panel = $(".faq-a", item);
        btn.addEventListener("click", function () {
          var isOpen = item.classList.contains("open");
          items.forEach(function (i) {
            i.classList.remove("open");
            var p = $(".faq-a", i);
            if (p) p.style.maxHeight = "0";
          });
          if (!isOpen) {
            item.classList.add("open");
            panel.style.maxHeight = panel.scrollHeight + 40 + "px";
          }
        });
      });
    });
  }

  /* ---------------- mobile menu ---------------- */
  function initMenu() {
    var burger = $("[data-burger]");
    var menu = $("[data-mobile-menu]");
    if (!burger || !menu) return;
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("show");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.classList.toggle("bkl-lock", open);
    });
    $all("a", menu).forEach(function (a) {
      a.addEventListener("click", function () { menu.classList.remove("show"); document.documentElement.classList.remove("bkl-lock"); });
    });
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("js-reveal");
    var sel = ".section-head,.bene-card,.rev-card,.stack-card,.dose-card,.formula-copy,.gcard,.faq-wrap,.stat,.aud-card";
    var els = $all(sel);
    els.forEach(function (el) { el.classList.add("reveal"); });
    $all(".bene-grid,.rev-grid,.stack-grid,.stats-inner,.aud-grid").forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (c, i) {
        if (c.classList.contains("reveal")) c.style.transitionDelay = (i * 70) + "ms";
      });
    });
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- global cart triggers ---------------- */
  function initGlobalCart() {
    drawer = $("[data-drawer]");
    scrim = $("[data-scrim]");
    if (!drawer) return;

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-cart-open]")) { e.preventDefault(); openCart(); }
      if (t.closest("[data-cart-close]") || t === scrim) { closeCart(); }
      if (t.closest("[data-checkout]")) { window.location.href = "/checkout"; }

      var line = t.closest(".ci");
      if (line) {
        var key = line.getAttribute("data-line-key");
        var qtyEl = $(".n", line);
        var current = parseInt(qtyEl ? qtyEl.textContent : "1", 10);
        if (t.closest("[data-qty-up]")) changeLine(key, current + 1);
        else if (t.closest("[data-qty-down]")) changeLine(key, Math.max(0, current - 1));
        else if (t.closest("[data-qty-remove]")) changeLine(key, 0);
      }
    });

    if (scrim) scrim.addEventListener("click", closeCart);

    document.addEventListener("keydown", function (e) {
      if (!cartIsOpen()) return;
      if (e.key === "Escape") { closeCart(); return; }
      if (e.key === "Tab") {
        // simple focus trap within the open drawer
        var f = drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // initial render
    fetchCart();
  }

  /* ---------------- boot ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    initGlobalCart();
    initProduct();
    initStack();
    initReviews();
    initFaq();
    initMenu();
    initReveal();
  });

  // expose for the theme editor / other scripts
  window.BKLCart = { open: openCart, close: closeCart, refresh: fetchCart, add: addToCart };
})();
